// text-page-title carries the size, line height and the 420 weight, so no
// separate font-weight class here; a bold would only be synthesised.
// Exported so screens that need a real heading element can wear the same
// treatment without restating it.
export const pageTitleClasses = 'text-page-title font-display text-heading';

const PageTitle = ({ title }) => {
   return (
      <div>
         <span className={pageTitleClasses}>{title}</span>
      </div>
   );
};

export default PageTitle;
